/* eslint-disable no-console */
import { CONFIG } from '../config';

export const loadFreshdeskScripts = (data = {}) => {
    // const script1 = document.createElement('script');
    // script1.innerHTML = `
    //         window.fwSettings={
    //           'widget_id':${CONFIG.FRESHDESK_WIDGET_ID}
    //         };
    //         !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}();
    //     `;
    // script1.onerror = () => {
    //     console.error('Failed to load Freshdesk');
    // };
    // document.body.appendChild(script1);

    // const script2 = document.createElement('script');
    // script2.src = `https://ind-widget.freshworks.com/widgets/${CONFIG.FRESHDESK_WIDGET_ID}.js`;
    // script2.async = true;
    // script2.defer = true;
    // script2.onerror = () => {
    //     console.error('Failed to load Freshdesk');
    // };
    // document.body.appendChild(script2);

    // script2.onload = () => {
    //     if (typeof FreshworksWidget === 'function') {
    //         window.FreshworksWidget('identify', 'ticketForm', {
    //             name: data?.name,
    //             email: data?.email,
    //         });

    //         window.FreshworksWidget('prefill', 'ticketForm', {
    //             custom_fields: {
    //                 cf_company_name: window.location.hostname.split('.')[0],
    //             },
    //         });

    //         window.FreshworksWidget('hide', 'ticketForm', ['custom_fields.cf_company_name'], {});
    //     } else {
    //         console.error('FreshworksWidget is not available.');
    //     }
    // };

    const script = document.createElement('script');
    script.src = `https://in.fw-cdn.com/32208262/1179713.js`;
    script.chat = true;
    script.widgetId = '9907a812-36f3-483c-8131-5b509df4289d';
    script.onerror = () => {
        console.error('Failed to load Freshdesk');
    };
    document.body.appendChild(script);

    return () => {
        try {
            document.body.removeChild(script);
            // document.body.removeChild(script1);
            // document.body.removeChild(script2);

            if (window.FreshworksWidget) {
                window.FreshworksWidget('destroy');
                delete window.FreshworksWidget;
            }

            if (window.fwSettings) {
                delete window.fwSettings;
            }
        } catch (error) {
            console.error('Error during Freshdesk cleanup:', error);
        }
    };
};
